import { Link } from "react-router-dom";
import "./ViewControls.css";

export function CompactLinkList({ items, label }) {
    return <ul className="compact-link-list" aria-label={label}>
        {items.map(item => <li key={item.name}>
            <Link to={item.to} title={item.description}>{item.name}</Link>
        </li>)}
    </ul>;
}
